import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {AttributeLambdaParameters} from "#template/nodes/geometry-graph/attribute/attribute-lambda/geometry-attribute-lambda-node"
import {
    GeometryAttributeLambdaNode,
    attributeLambdaParametersSchema,
} from "#template/nodes/geometry-graph/attribute/attribute-lambda/geometry-attribute-lambda-node"

export type PointGeometryAttributeLambdaParameters = AttributeLambdaParameters<0>

const definition: TemplateNodeDefinition<PointGeometryAttributeLambdaParameters> = {
    nodeClass: "PointGeometryAttributeLambda",
    validation: {
        parameters: attributeLambdaParametersSchema<0>(),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryAttributeLambda
    extends GeometryAttributeLambdaNode<0, PointGeometryAttributeLambdaParameters>
    implements PointGeometryAttributeLikeNode
{
    get [pointGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
